import { ContentGroup } from "../../../../../core/resource/types";
import { formatMessage } from "../../../../../utils";

export function printDuration(duration: number, cr: ContentGroup): string {
  const { day, hour, minute } = calculateDurationParts(duration);

  const dStr = formatMessage(cr.durationD, { d: day });
  const hStr = formatMessage(cr.durationH, { h: hour });
  const mStr = formatMessage(cr.durationM, { m: minute });

  if (day !== 0) {
    return `${dStr} ${hStr} ${mStr}`;
  }

  if (hour !== 0) {
    return `${hStr} ${mStr}`;
  }

  return `${mStr}`;
}

function calculateDurationParts(duration: number) {
  const rawDay = duration / 60 / 24;
  const rawHour = (duration / 60) % 24;
  const rawMinute = duration % 60;

  if (duration < 0) {
    const day = Math.ceil(rawDay);
    const hour = (day !== 0 ? -1 : 1) * Math.ceil(rawHour);
    const minute = (day !== 0 || hour !== 0 ? -1 : 1) * Math.ceil(rawMinute);

    return {
      day,
      hour,
      minute,
    };
  }

  return {
    day: Math.floor(rawDay),
    hour: Math.floor(rawHour),
    minute: Math.floor(rawMinute),
  };
}
